import React, { useState,useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select, { components} from "react-select";
import { toast } from 'react-toastify';
import axios from 'axios';

const AssignVehicle = ({ show, onClose, data, refresh }) => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [loading, setLoading] = useState(false);

    // const [staffoption, setstaffopt] = useState([]);
    // const [staff, setstaff] = useState(null);
    // const [selstaff, setSelstaff] = useState(null);
    // useEffect (() => {
    //     axios.get(`${baseURL}/dropdown/get_staffs`, {params: {branch_id}})
    //     .then(response => {
    //         const formattedsource = response.data.data.map(item => ({
    //             value: item.sno,
    //             label: item.employee_name,
    //         }));
    //         setstaffopt(formattedsource);
    //     })
    //     .catch(error => {
    //         console.log(error);
    //     });
    // }, []);

    const [vehiopt, setvehiopt] = useState([]);
    const [vehicle, setvehicle] = useState(null);
    const [selvehicle, setSelvehicle] = useState(null);
    useEffect (() => {
        axios.get(`${baseURL}/dropdown/get_vehicles`, {params: {branch_id}})
        .then(response => {
            const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                title: item.vehicle_brand,
                subtitle: item.vehicle_number,
                label: item.vehicle_brand,
            }));
            setvehiopt(formattedsource);
        })
        .catch(error => {
            console.log(error);
        });
    }, []);

    // const [mealspointopt, setmealspointopt] = useState([]);
    // const [mealspoint, setmealspoint] = useState(null);
    // const [selmealspoint, setSelmealspoint] = useState(null);
    // useEffect (() => {
    //     axios.get(`${baseURL}/meals_point/getactive`, {params: {branch_id: branch_id}})
    //     .then(response => {
    //         const formattedsource = response.data.map(item => ({
    //             value: item.sno,
    //             label: item.name,
    //         }));
    //         setmealspointopt(formattedsource);
    //     })
    //     .catch(error => {
    //         console.log(error);
    //     });
    // }, []);

    // const [delivery_type, setdelivery_type] = useState(0);

    useEffect(() => {
        if(data){
            setvehicle(vehiopt.find(opt=> opt.value === data.vehicle_id)?.value ?? null);
            setSelvehicle(vehiopt.find(opt=> opt.value === data.vehicle_id));

            // if(data.delivery_type === 0){
            //     setdelivery_type(0);
            //     setstaff(data.staff_id);
            //     setSelstaff(staffoption.find(op=> op.value === data.staff_id));
            //     setvehicle(data.vehicle_id);
            //     setSelvehicle(vehiopt.find(opt=> opt.value === data.vehicle_id));
            // } else if(data.delivery_type === 1){
            //     setdelivery_type(1);
            //     setmealspoint(data.meals_point_id);
            //     setSelmealspoint(mealspointopt.find(opt=> opt.value === data.meals_point_id));
            // } else {
            //     setdelivery_type(0);
            // }
        }
    }, [data, vehiopt]);

    const Group = (props) => (
        <div style={customStyles}>
            <components.Group {...props} />
        </div>
    );

    const customStyles = {
        groupHeading: (provided) => ({
            ...provided,
            fontSize: '14px',  // Increase the font size for group labels
            fontWeight: 'bold',  // Optional: make the label bold
            color: '#333',  // Optional: change the text color
        }),
    };

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};

        if(!vehicle){
            newErrors.vehicle = 'This Field is Required.';
        }

        // if(delivery_type === 0) {
        //     if(!staff){
        //         newErrors.staff = 'This Field is Required.';
        //     }
        //     if(!vehicle){
        //         newErrors.vehicle = 'This Field is Required.';
        //     }
        // } else {
        //     if(!mealspoint){
        //         newErrors.mealspoint = 'This Field is Required.';
        //     }
        // }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        // let postData;

        // if(delivery_type === 0) {
        //     postData = { 
        //         delivery_type: delivery_type,
        //         vehicle_id: vehicle,
        //         staff_id: staff
        //     };
        // } else {
        //     postData = { 
        //         delivery_type: delivery_type,
        //         meals_point_id: mealspoint,
        //     };
        // }

        let postData = {  vehicle_id: vehicle };
        
        setLoading(true);
        // Send the request to the backend
        axios.post(`${baseURL}/dropdown/store_vehicle/${data.sno}`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Vehicle Assigned Successfully!");
                setLoading(false);
            })
            .catch(error => {
                console.error("Error:", error);
                toast.error("Vehicle Assignment Failed");
                setLoading(false);
            });
    };


    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Assign Delivery Vehicle</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-black font-w500 fs-7'>Branch</label>
                            <label className='text-primary fs-3 font-w500'>{data.branch_data?.branch_name? data.branch_data.branch_name : '-'}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-black font-w500 fs-7'>Delivery Point</label>
                            <label className='text-primary fs-3 font-w500'>{data.delivery_point}</label>
                        </div>

                        <div className="col-lg-12 mb-3">
                            <label className="text-black font-w500 fs-7">Vehicle<span className="required">*</span></label>
                            <Select  placeholder="Select Vehicle"
                                options={vehiopt}
                                value={selvehicle}
                                onChange={(e)=> {
                                    setvehicle(e.value);
                                    setSelvehicle(e);
                                }}
                                styles={customStyles}
                                components={{
                                    Option: (props) => {
                                        const { data, innerRef, innerProps, isFocused, isSelected } = props;
                                        return (
                                            <div ref={innerRef} {...innerProps} style={{ backgroundColor: isFocused ? '#eee' : isSelected ? '#ddd' : 'white', padding: 10, cursor: 'pointer',}}>
                                                <div style={{ fontWeight: 'bold', fontSize: '1rem', color: '#333' }}>
                                                    {data.title}
                                                </div>
                                                <div style={{ fontSize: '0.8rem', color: '#666' }}>
                                                    {data.subtitle}
                                                </div>
                                            </div>
                                        );
                                    },
                                    Group,
                                }}
                            
                            />
                            {errors.vehicle && <small className="text-danger">{errors.vehicle}</small>}
                        </div>

                        {/* <div className="row">
                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex align-items-center mb-3'>
                                <input type="radio" id="option1" name="deliveryOption" value="option1" className="me-2" style={{ transform: 'scale(1.4)', marginRight: '1rem' }} onChange={() => setdelivery_type(0)} checked={delivery_type === 0 ? true : false}/>
                                <label htmlFor="option1" className="text-black mb-0 fs-6 font-w500">
                                    Our Staff
                                </label>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex align-items-center mb-3'>
                                <input type="radio" id="option2" name="deliveryOption" value="option2" className="me-2" style={{ transform: 'scale(1.4)', marginRight: '1rem' }} onChange={() => setdelivery_type(1)} checked={delivery_type === 1 ? true : false}/>
                                <label htmlFor="option2" className="text-black mb-0 fs-6 font-w500">
                                    Meals Point
                                </label>
                            </div>
                        </div>
                        {delivery_type === 0 ? (
                            <>
                                <div className="col-lg-12 mb-3">
                                    <label className="text-black font-w500 fs-7">Staff<span className="required">*</span></label>
                                    <Select  placeholder="Select Staff"
                                        options={staffoption}
                                        value={selstaff}
                                        onChange={(e)=> {
                                            setstaff(e.value);
                                            setSelstaff(e);
                                        }}
                                    />
                                    {errors.staff && <small className="text-danger">{errors.staff}</small>}
                                </div>
                                <div className="col-lg-12 mb-3">
                                    <label className="text-black font-w500 fs-7">Vehicle<span className="required">*</span></label>
                                    <Select  placeholder="Select Vehicle"
                                        options={vehiopt}
                                        value={selvehicle}
                                        onChange={(e)=> {
                                            setvehicle(e.value);
                                            setSelvehicle(e);
                                        }}
                                        styles={customStyles}
                                        components={{
                                            Option: (props) => {
                                                const { data, innerRef, innerProps, isFocused, isSelected } = props;
                                                return (
                                                    <div ref={innerRef} {...innerProps} style={{ backgroundColor: isFocused ? '#eee' : isSelected ? '#ddd' : 'white', padding: 10, cursor: 'pointer',}}>
                                                        <div style={{ fontWeight: 'bold', fontSize: '1rem', color: '#333' }}>
                                                            {data.title}
                                                        </div>
                                                        <div style={{ fontSize: '0.8rem', color: '#666' }}>
                                                            {data.subtitle}
                                                        </div>
                                                    </div>
                                                );
                                            },
                                            Group,
                                        }}
                                    
                                    />
                                    {errors.vehicle && <small className="text-danger">{errors.vehicle}</small>}
                                </div>
                            </>
                        ) : (
                            <>
                            <div className="col-lg-12 mb-3">
                                <label className="text-black font-w500 fs-7">Meals Point<span className="required">*</span></label>
                                <Select  placeholder="Select Meals Point"
                                    options={mealspointopt}    
                                    value={selmealspoint}
                                    onChange={(e)=> {
                                        setmealspoint(e.value);
                                        setSelmealspoint(e);
                                    }}
                                />
                                {errors.mealspoint && <small className="text-danger">{errors.mealspoint}</small>}
                            </div>
                            </>
                        )} */}
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <button type="submit" className={`btn btn-sm btn-primary ${loading ? 'disabled' : ''} `} onClick={handleSubmit}>{loading ? 'Loading...' : 'Assign Vehicle'} <i className="fas fa-angle-double-right ms-2"></i></button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AssignVehicle;
